<template>
  <el-col :span="span" class="label_item">
    <div class="label_item_label">{{ label }}：</div>
    <div class="label_item_value">
      <slot v-if="custom" name="value" :value="value"></slot>
      <template v-else>
        <router-link v-if="to" :to="to">{{ value }}</router-link>
        <el-link :underline="false" v-else-if="href" :href="href" :target="target">
          {{ value }}
        </el-link>
        <span v-else :style="valueStyle">{{ value }}</span>
      </template>
    </div>
  </el-col>
</template>
<script>
export default {
  name: 'LabelItem',
  props: {
    span: {
      type: Number,
      default: 12
    },
    label: String,
    value: [String, Object, Array],
    valueStyle: Object,
    to: [Object, String],
    href: String,
    target: String,
    custom: Boolean
  }
};
</script>
<style lang="scss" scoped>
.label_item {
  display: flex;
  padding: 10px 0;
  .label_item_label {
    min-width: 70px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 400;
    font-size: 14px;
    line-height: 1.5715;
  }
  .label_item_value {
    // color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    line-height: 1.5715;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LabelItem/index.vue